import Heading from "components/Heading";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Col, Container, Row, Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem, Alert
} from "reactstrap";
import { toLocaleTime } from "utils/Api";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { PO_BOX_PREFIX } from "utils/Constants";
import LoadingTBody from "components/LoadingTBody";
import { getPoBoxesByDate } from "api/POBoxApi";
import DynamicForm from "components/DynamicForm";
import { debounce } from "lodash";
import { useAmplifyIncrementalList } from "utils/hooks/useAmplifyIncrementalList";

const PAGE_SIZE_LIMIT = 100

const PoBoxMovement = props => {
  let navigate = useNavigate();
  const [typeAheadFilter, setTypeAheadFilter] = useState("");

  const buildPoBoxFilter = (filter) => {
    const q = (filter || "").trim();
    if (!q) return null;

    return {
      or: [
        { name: { contains: q } },
        { email: { contains: q } },
        { boxNumber: { eq: q } },
      ],
    };
  };

  const {
    items: poBoxes,
    isLoadingInitial,
    isLoadingMore,
    isSearching,
    bottomRef,
  } = useAmplifyIncrementalList({
    fetchPage: getPoBoxesByDate,
    searchText: typeAheadFilter,
    buildFilter: buildPoBoxFilter,
    pageSize: PAGE_SIZE_LIMIT,
  });

  const isLoading = isLoadingInitial || isLoadingMore || isSearching;

  const renderList = () => {
    return poBoxes.map((poBox) => {
      let created = toLocaleTime(poBox.createdAt);
      return (
        <tr key={poBox.id}>
          <td>
            {PO_BOX_PREFIX}-{poBox.boxNumber}
          </td>
          <td>
            {poBox.name}
          </td>
          <td>
            {poBox.email}
          </td>
          <td>
            {poBox.phone || ""}
          </td>
          <td>
            {created}
          </td>
          <td>
            {rowActions(poBox)}
          </td>
        </tr>
      );
    });
  }

  const rowActions = (poBox) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/packagesByPoBox/${poBox.id}`) }}>
            Ver Paquetes
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  const getSearchForm = () => {
    return {
      sections: [{
        fields: [
          [
            {
              "type": "text",
              "name": "q",
              "label": "Filtro",
              "disabled": false,
              "sizing": {
                "sm": 6
              }
            },
          ]
        ]
      }]
    };
  }

  const typeAHeadSearch = debounce((search) => {
    setTypeAheadFilter(search);
  }, 500)

  return (
    <>
      <Heading headingLevel="h2" className="pt-4" label="Casilleros" sticky >
      </Heading>
      <DynamicForm
        id="search"
        formConfig={getSearchForm()}
        onInputChange={(fieldName, v) => typeAHeadSearch(v)}>

      </DynamicForm>
      <Container>
        <Row>
          <Col>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Nombre Cliente
                  </th>
                  <th>
                    Email
                  </th>
                  <th>
                    Telefono
                  </th>

                  <th>
                    Fecha Creacion
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <LoadingTBody
                aheadLoading
                extraColumns={false}
                isLoading={isLoading}>
                {renderList()}
                {
                  poBoxes.length == 0 && typeAheadFilter && !isLoading && (
                    <tr>
                      <td colSpan="20">
                        <b>No se encontro ningun resultado con el filtro ingresado</b>
                      </td>
                    </tr>
                  )
                }
                <tr>
                  <td colSpan="20">
                    <div ref={bottomRef} style={{ height: 1 }} />
                  </td>
                </tr>
              </LoadingTBody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PoBoxMovement;
